import { trim } from 'lodash';
import { array, mixed, number, object, string } from 'yup';

import { ChatMessageActionType } from '../../../../../data/data/enums';
import { ConsultType, Honorific } from '../../../../../data/types/api/graphql';
import { messages } from '../../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    type: mixed<ChatMessageActionType>()
      .oneOf(Object.values(ChatMessageActionType))
      .required(messages.required.id),
    consultTypes: array(mixed<ConsultType>().oneOf(Object.values(ConsultType)))
      .when('type', {
        is: (type: ChatMessageActionType) =>
          type === ChatMessageActionType.APPOINTMENT,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default([ConsultType.Physical]),
    honorifics: array(
      object().shape({
        key: mixed<Honorific>()
          .transform(value => {
            // Handle null/undefined correctly
            if (value === null || value === undefined) {
              return undefined; // Will trigger required validation
            }
            return value;
          })
          .oneOf(Object.values(Honorific))
          .required(messages.required.id),
        value: number().required(messages.required.id),
      })
    ).when('type', {
      is: (type: ChatMessageActionType) =>
        type === ChatMessageActionType.APPOINTMENT,
      then: currentSchema => currentSchema.required(messages.required.id),
    }),

    healthProfessionalId: string().transform(trim).default(''),
    text: string().transform(trim),
  })
  .required()
  .noUnknown();
